import React from 'react';
import classnames from 'classnames';
import { Pane } from '@leverege/ui-elements';
import { Context } from '@leverege/plugin';
import { RendererFactory } from './Factory.js';
import DetailHeader from "./DetailHeader.js";
import DetailFooter from "./DetailFooter.js";
import Style from './Style.js';
import Model from './DetailListModel.js';
import S from './DetailListCard.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class DetailListCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      model: null,
      renderers: []
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (props.model !== state.model) {
      const renderers = [];
      props.model.details.forEach(d => {
        const rnd = RendererFactory.create(d);
        if (rnd != null) {
          renderers.push(rnd);
        }
      });
      return {
        model: props.model,
        renderers
      };
    }
    return null;
  }
  getRenderers(model, item, context) {
    const {
      renderers
    } = this.state;
    const rdr = [];
    let c = 0;
    let isOdd = false;
    for (let n = 0; n < renderers.length; n++) {
      if (renderers[n] == null) {
        continue;
      }
      const r = renderers[n].getComponents(item, context);
      const oddEven = isOdd ? S.odd : S.even;
      if (Array.isArray(r)) {
        if (r.length === 1) {
          rdr.push(/*#__PURE__*/_jsx("div", {
            className: S.customCell,
            children: /*#__PURE__*/_jsx("div", {
              className: classnames(S.value, oddEven),
              style: toCellStyle(r[0].style),
              children: r[0].component
            })
          }, c++));
          isOdd = !isOdd;
        } else if (r.length === 2) {
          rdr.push(/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("div", {
              className: classnames(S.label, oddEven),
              style: toCellStyle(r[0].style),
              children: r[0].component
            })
          }, c++));
          rdr.push(/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("div", {
              className: classnames(S.value, oddEven),
              style: toCellStyle(r[1].style),
              children: r[1].component
            })
          }, c++));
          isOdd = !isOdd;
        }
      } else if (r) {
        rdr.push(/*#__PURE__*/_jsx("div", {
          className: S.customCell,
          children: /*#__PURE__*/_jsx("div", {
            className: classnames(S.custom, oddEven),
            style: toCellStyle(r.style),
            children: r.component
          })
        }, c++));
        isOdd = !isOdd;
      }
    }
    return rdr;
  }
  render() {
    const {
      context,
      model,
      domRef,
      headerControls,
      footerControls
    } = this.props;
    const target = Context.getTarget(context);
    if (target == null) {
      return null;
    }
    const style = {
      minWidth: model.minWidth || '100px',
      background: model.background
    };
    if (model.labelColor && model.labelColor.length !== 0) {
      style['--color-detailLabel'] = model.labelColor;
    }
    if (model.valueColor && model.valueColor.length !== 0) {
      style['--color-detailValue'] = model.valueColor;
    }
    if (model.suffixColor && model.suffixColor.length !== 0) {
      style['--color-detailSuffix'] = model.suffixColor;
    }
    if (model.evenRowBackground && model.evenRowBackground.length !== 0) {
      style['--color-detailEvenRow'] = model.evenRowBackground;
    }
    if (model.oddRowBackground && model.oddRowBackground.length !== 0) {
      style['--color-detailOddRow'] = model.oddRowBackground;
    }
    const variant = Style.buildDetailVariant(model.variant, 'Card');
    const headerVariant = Style.buildDetailVariant(model.variant, 'Header');
    const contentVariant = Style.buildDetailVariant(model.variant, 'Content');
    const footerVariant = Style.buildDetailVariant(model.variant, 'Footer');
    const titleVariant = Style.buildDetailVariant(model.variant, 'Title');
    return /*#__PURE__*/_jsxs(Pane, {
      ref: domRef,
      variant: variant,
      style: style,
      children: [model.header.visible && /*#__PURE__*/_jsx(Pane, {
        variant: headerVariant,
        children: /*#__PURE__*/_jsx(DetailHeader, {
          variant: titleVariant,
          target: target,
          header: model.header,
          context: context,
          headerControls: Model.getHeaderControlsVisible(model) ? headerControls : null,
          iconSize: model?.header?.icon?.size
        })
      }), /*#__PURE__*/_jsx(Pane, {
        variant: contentVariant,
        className: S.grid,
        children: this.getRenderers(model, target, context)
      }), Model.getFooterVisible(model) && /*#__PURE__*/_jsx(Pane, {
        variant: footerVariant,
        children: /*#__PURE__*/_jsx(DetailFooter, {
          target: target,
          header: model.footer,
          context: context,
          footerControls: footerControls
        })
      })]
    });
  }
}
function toCellStyle(s) {
  if (s) {
    const r = {};
    if (s.background) {
      r.background = s.background;
    }
    if (s.justify) {
      r.justifyContent = Style.toFlexJustify(s.justify);
    }
    if (s.align) {
      r.alignItems = Style.toFlexAlign(s.align);
    }
    if (s.padding) {
      r.padding = s.padding;
    }
    return r;
  }
  return null;
}